import { FEE_RULES_ROUTE_PATHS } from './fee-rules/config';
import { EXPATRIATIONS_ROUTE_PATHS } from './expatriations/config';

export const FINANCE_ROUTE_PATHS = {
  ...FEE_RULES_ROUTE_PATHS,
  ...EXPATRIATIONS_ROUTE_PATHS,
};
